/* src/Process.svelte generated by Svelte v3.23.0 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	space,
	text
} from "/web_modules/svelte/internal.js";

function create_fragment(ctx) {
	let div0;
	let t1;
	let div1;
	let label;
	let t2;
	let t3;
	let t4;
	let progress_1;
	let t5;
	let t6_value = Math.round(/*progress*/ ctx[1] * 10) / 10 + "";
	let t6;
	let t7;

	return {
		c() {
			div0 = element("div");
			div0.textContent = "Processing...";
			t1 = space();
			div1 = element("div");
			label = element("label");
			t2 = text(/*loadState*/ ctx[0]);
			t3 = text(":");
			t4 = space();
			progress_1 = element("progress");
			t5 = space();
			t6 = text(t6_value);
			t7 = text(" % complete");
			attr(label, "for", "progress");
			attr(progress_1, "id", "progress");
			attr(progress_1, "max", "100");
			progress_1.value = /*progress*/ ctx[1];
		},
		m(target, anchor) {
			insert(target, div0, anchor);
			insert(target, t1, anchor);
			insert(target, div1, anchor);
			append(div1, label);
			append(label, t2);
			append(label, t3);
			append(div1, t4);
			append(div1, progress_1);
			append(div1, t5);
			append(div1, t6);
			append(div1, t7);
		},
		p(ctx, [dirty]) {
			if (dirty & /*loadState*/ 1) set_data(t2, /*loadState*/ ctx[0]);

			if (dirty & /*progress*/ 2) {
				progress_1.value = /*progress*/ ctx[1];
			}

			if (dirty & /*progress*/ 2 && t6_value !== (t6_value = Math.round(/*progress*/ ctx[1] * 10) / 10 + "")) set_data(t6, t6_value);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div0);
			if (detaching) detach(t1);
			if (detaching) detach(div1);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { loadState } = $$props;
	let { progress } = $$props;

	$$self.$set = $$props => {
		if ("loadState" in $$props) $$invalidate(0, loadState = $$props.loadState);
		if ("progress" in $$props) $$invalidate(1, progress = $$props.progress);
	};

	return [loadState, progress];
}

class Process extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { loadState: 0, progress: 1 });
	}
}

export default Process;